'use client';
import { Box, Stack } from '@mui/material';
import { NavLinkType, SettingsProps } from '../types';
import Optional from '../../../Optional';
import RichCtaButton from '../../../elements/RichCtaButton';
import NavDropdown from '../common/NavDropdown';

type Props = SettingsProps & {
  linksOverride?: NavLinkType[];
  hideCta?: boolean;
};

const DesktopMenu = ({ navigation, linksOverride, hideCta }: Props) => {
  const { links, cta } = navigation;
  const displayLinks = linksOverride ?? links;
  return (
    <Box
      component={'nav'}
      sx={{
        height: '100%',
        display: { xs: 'none', md: 'flex' },
        alignItems: 'center',
      }}
    >
      <Stack
        spacing={2}
        direction={'row'}
        sx={{
          p: 1,
          pl: 2,
          background: (theme) => theme.palette.background.default,
          borderRadius: 1,
        }}
      >
        {displayLinks?.map((link) => (
          <NavDropdown key={link.label} link={link} />
        ))}
        <Optional condition={!!cta && !hideCta}>
          <RichCtaButton
            cta={cta}
            track={{
              position: 'nav',
            }}
          />
        </Optional>
      </Stack>
    </Box>
  );
};

export default DesktopMenu;
